import api, { createApiService } from "../http";
import { AllMessagesRequest, IMessage, LastMessageAndUserAllRequest } from "../types/services-types/messages-types";

export default class MessageService {

    static apiMessageService = createApiService('/message')

    static async GetAll(chat_id: number | string, limit: string | number, page: string | number) {
        const response = await this.apiMessageService.get<AllMessagesRequest>('/all', {
            params: {
                chat_id,
                limit,
                page
            }
        })
        return response.data
    }

    static async GetAllUsersAndlastMessage(limit: string | number, page: string | number) {
        const response = await this.apiMessageService.get<LastMessageAndUserAllRequest>('/all-users-message', {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async Create(chat_id: number | string, message: string) {
        const response = await this.apiMessageService.post<IMessage>(`/create/${chat_id}`, {
            message
        })
        return response.data
    }


    static async Update<IMessage>(id: number, newMessage: string) {
        const response = await this.apiMessageService.post<IMessage>(`/update/${id}`, {
            newMessage
        })
        return response.data
    }

    static async Remove(id: number) {
        const response = await this.apiMessageService.get<number>(`/delete/${id}`)
        return response.data
    }
}